import React, { FC } from 'react';
import { Image, Flex } from '@chakra-ui/react';
interface LoaderProps {}

const Loader: FC<LoaderProps> = () => {
  const loaderImage = require('../../assets/loader/Loader_fast.gif');
  return (
    <>
      <Flex
        align={'center'}
        justify={'center'}
        h='100%'
        w='100%'
        bg='background.loader'
      >
        <Image boxSize={['200px']} src={loaderImage}></Image>
      </Flex>
    </>
  );
};

export default Loader;
